import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import api from '../requests/api.js';

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
});


router.beforeEach(async (to, from, next) => {
    //Nos casos onde o path da url seja referente ao ato no DOM legado redireciona para o ato correspondente  
    //ou para pagina inicial no novo DOM
    if(to.path == '/dom/iniciaEdicao.do'){
        if(to.query.method == 'DetalheArtigo'){
            const idAtoLegado =  to.query.pk;
            const ato = await api.ato.obterPorIdAtoLegado(idAtoLegado).then(response => {
                return response?.status == 200 ? response.data.data : null;
            })
            
            if(ato){
                router.push({name: 'visualizacaoAto',  params: { id: ato.id } });
            }else{
                router.push({name: 'home'});
            }
        }else if(to.query.method == 'DomDia'){
            router.push({name: 'home'});
        }
    }

    next()
});



export default router;